// Copyright Abridged, Inc. 2022,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - WalletChallengeRequest
 * WalletChallengeRequest
 */
@model({name: 'WalletChallengeRequest'})
export class WalletChallengeRequest {
  constructor(data?: Partial<WalletChallengeRequest>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   * State/nonce from the client
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'State/nonce from the client',
    },
  })
  state?: string;

  /**
   * URI referring to the resource that is the subject of the signing (as in the
subject of a claim).
   */
  @property({
    jsonSchema: {
      type: 'string',
      description:
        'URI referring to the resource that is the subject of the signing (as in the subject of a claim).',
    },
  })
  uri?: string;

  /**
   * Domain name of the server that is requesting the signature.
   */
  @property({
    jsonSchema: {
      type: 'string',
      description:
        'Domain name of the server that is requesting the signature.',
    },
  })
  domain?: string;

  /**
   * Account id of the signer
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Account id of the signer',
    },
  })
  accountId?: string;

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
        description: 'Resources requested for access',
      },
    },
  })
  resources?: string[];
}

export interface WalletChallengeRequestRelations {
  // describe navigational properties here
}

export type WalletChallengeRequestWithRelations = WalletChallengeRequest &
  WalletChallengeRequestRelations;
